import { CellAlign, CellType, HeadCell } from '@dfl/mui-admin-layout';
import { ProductCell, ReductionCauseCell, WarehouseAreaCell } from './common.column';
import { AvatarNameCell } from 'modules/common/components/AvatarNameCell';
import { WAREHOUSE_PERMISSIONS } from 'modules/inventory/warehouse/constants';

// only warehouse product stock
export const productColumn: HeadCell = {
  field: 'response.payload.item',
  headerName: 'product:name',
  component: ProductCell,
  sortable: false,
  maxWidth: 200,
};
export const areaColumn: HeadCell = {
  field: 'response.payload.warehouseArea',
  headerName: 'warehouseArea:select',
  component: WarehouseAreaCell,
  sortable: false,
};
export const warehouseColumn: HeadCell = {
  field: 'warehouseName',
  headerName: 'stock:fields.warehouse',
  sortable: false,
  renderCell: (value: string, warehouse: any) => (
    <AvatarNameCell
      variant={'rounded'}
      name={value}
      link={`/inventory/warehouses/${warehouse?.warehouse as string}/general`}
      hideImage
      permissions={[WAREHOUSE_PERMISSIONS.WAREHOUSE_VIEW]}
    />
  ),
};
export const reductionCauseColumn: HeadCell = {
  field: 'response.payload.cause',
  headerName: 'stock:fields.reductionCause',
  component: ReductionCauseCell,
  sortable: false,
};

export const reductionColumn: HeadCell = {
  field: 'response.payload.quantity',
  headerName: 'stock:fields.reduction',
  align: CellAlign.CENTER,
  type: CellType.NUMBER,
  sortable: false,

  renderCell: (quantity: number) => `-${quantity}`,
};

export const dataErrorInsufficientStockColumn = [
  productColumn,
  warehouseColumn,
  // areaColumn,
  reductionCauseColumn,
  reductionColumn,
];
